import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PButtonPure, PIcon } from '@porsche-design-system/components-react';

import { Spacer } from './Spacer';

const Bar = styled('div', {
  base: {
    display: 'grid',
    backgroundColor: 'background.surface',
    gridTemplateColumns: '1fr auto',
    overflow: 'hidden',
  },

  variants: {
    isOpen: {
      true: {
        borderTopLeftRadius: 'xl',
        borderTopRightRadius: 'xl',
        borderBottomWidth: 0,
      },
      false: {
        borderRadius: 'xl',
      },
    },
  },
});

const Toggle = styled('div', {
  base: {
    padding: 'md',
    cursor: 'pointer',
  },
});

const Reset = styled('div', {
  base: {
    padding: 'md',
  },
});

const Content = styled('div', {
  base: {
    padding: 'md',
    marginBottom: 'md',
    backgroundColor: 'background.surface',
    borderBottomLeftRadius: 'xl',
    borderBottomRightRadius: 'xl',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 'md',

    sm: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
});

export const FilterBar = ({
  isOpen,
  onToggle,
  onReset,
  activeFilterText,
  i18n,
  children,
}: {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onReset: () => void;
  activeFilterText?: React.ReactNode;
  i18n: {
    add: string;
    toggle: string;
    reset: string;
  };
  children: React.ReactNode;
}) => {
  return (
    <>
      <Spacer mt="md" />
      <Bar isOpen={isOpen}>
        <Toggle
          role="button"
          aria-label={i18n.toggle}
          onClick={() => onToggle(!isOpen)}
        >
          {activeFilterText ? (
            activeFilterText
          ) : (
            <>
              <PIcon name="filter" />
              {i18n.add}
            </>
          )}
        </Toggle>
        <Reset onClick={onReset}>
          <PButtonPure icon="none">{i18n.reset}</PButtonPure>
        </Reset>
      </Bar>

      {isOpen && <Content>{children}</Content>}

      <Spacer mb="md" />
    </>
  );
};
